<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <h3>订单维度<span class="time">续报人数、续报率、续报金额的数据更新时间为 T+1</span></h3>
        <div class="refresh">按照订单维度汇总的完整数据链路，按体验课订单支付时间周期来统计</div>
      </div>
      <div class="topRight">
        <el-select v-model="listQuery.dimension" class="selectWidth" @change="toggleSearch">
          <el-option
            v-for="item in allTime"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="createTime"
          value-format="timestamp"
          type="daterange"
          :picker-options="pickerOptions"
          :clearable="false"
          @blur="enableChoose"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          style="width:235px"
          @change="changeDate"
        ></el-date-picker>
        <div>按体验课订单支付时间统计</div>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="课程科目" label-width="80px">
          <SubjectCascader :onChange="subjectCascaderChange" />
        </el-form-item>
        <el-form-item label="推广课程">
          <el-select
            value-key="id"
            v-model="listQuery.course_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广课程"
          >
            <el-option label="全部推广课程" value="all" />
            <el-option
              v-for="item in courseList"
              :key="item.id"
              :label="item.agentCourse.name"
              :value="item.agentCourse.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广渠道">
          <el-select
            value-key="id"
            v-model="listQuery.promotion_channel_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广渠道"
            @change="handleChannel"
          >
            <el-option label="全部推广渠道" value="all" />
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionChannelCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广位">
          <el-select
            value-key="id"
            v-model="listQuery.promotion_position_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广位"
          >
            <el-option label="全部推广位" value="all" />
            <el-option
              v-for="item in promotionList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionPositionCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="进班时间" label-width="80px">
          <el-date-picker
            v-model="classDate"
            value-format="timestamp"
            type="daterange"
            :clearable="true"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:235px"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="学习进度">
          <el-select v-model="listQuery.study_step" filterable placeholder="请选择学习进度">
            <el-option :key="0" label="全部" value="all" />
            <el-option :key="1" label="首课已开课" value="首课已开课" />
            <el-option :key="2" label="首课未开课" value="首课未开课" />
            <el-option :key="3" label="续报已截止" value="续报已截止" />
            <el-option :key="4" label="续报未截止" value="续报未截止" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="开课日期" label-width="80px">
          <el-date-picker
            v-model="listQuery.class_open_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="学期">
          <el-select
            v-model="listQuery.term_id"
            value-key="id"
            multiple
            filterable
            clearable
            placeholder="请选择学期"
          >
            <el-option label="全部" value="all" />
            <el-option
              v-for="item in termList"
              :key="item.id"
              :label="`${item.id}·${item.name}(${item.description})`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="归属人">
          <el-select
            value-key="id"
            v-model="listQuery.member_id"
            multiple
            filterable
            clearable
            placeholder="请选择归属人"
          >
            <el-option label="全部归属人" value="all" />
            <el-option
              v-for="item in teamList"
              :key="item.id"
              :label="item.name"
              :value="item.agentCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID">
          <el-input
            v-model="listQuery.promotion_link_id"
            placeholder="多个ID用逗号分隔"
            class="orderStyle"
          />
        </el-form-item>
        <el-form-item label="渠道组ID">
          <el-select
            v-model="listQuery.channel_group_id"
            filterable
            multiple
            clearable
            placeholder="输入渠道组ID查询"
            :loading="selectLoading"
          >
            <el-option
              v-for="item in channelGroups"
              :key="item.channelGroupId"
              :label="`${item.channelGroupId}${item.channelGroupName}`"
              :value="item.channelGroupId"
            />
          </el-select>
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
      <funcBlock tit="详细数据" :showBorder="false">
        <div slot="blockCon">
          <i slot="blockTit" class="blockTit">
            <el-button type="primary" icon="el-icon-download" @click="downloadTable">下载表格</el-button>
          </i>
          <el-table
            v-loading="listLoading"
            :data="dataList"
            border
            fit
            highlight-current-row
            style="width: 100%"
            :header-cell-style="tableHeader"
            :row-class-name="tableRowClassName"
            @sort-change="changeTableSort"
            :default-sort="{ prop: 'dimension', order: 'descending' }"
          >
            <el-table-column label="日期" prop="dimension" align="center" min-width="140" fixed sortable="custom">
              <template slot-scope="{ row }">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ `总计 ${total ? numberFormat(total) : total} 条记录` }}
                </span>
                <span v-else>{{ row.dimension || '--' }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="团队" prop="team_name" align="center" min-width="140" fixed>
              <template slot-scope="{ row }">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else>{{ row.team_name || '--' }}</span>
              </template>
            </el-table-column> -->
            <el-table-column
              v-for="column in orderColumns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :show-overflow-tooltip="true"
              align="center"
              min-width="150"
              sortable="custom"
            >
              <template slot="header" v-if="column.label && column.label.includes('率')">
                <el-tooltip class="item" effect="dark" :content="`${column.label} = ${column.label.replace(/率(-订单|（不含退费）)?$/, '量')} / 来量`" placement="top">
                  <span class="icon-question">{{ column.label }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ formatCellValue(row[column.prop], column.label) }}
                </span>
                <span v-else>{{ formatCellValue(row[column.prop], column.label) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total >= 1"
            :total="total"
            :page.sync="listQuery.index"
            :limit.sync="listQuery.pageSize"
            @pagination="getList"
          />
        </div>
      </funcBlock>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie'
import Pagination from '@/components/Pagination/index'
import SubjectCascader from '@/components/SubjectCascader'
import { getOrderFormTitle, getOrderFormList, getOrderFormNum, downloadOrderForm, getChannelList } from '@/services/time'
import { getCourseList, getChannelGroup } from '@/services/order'
import { getTeamList } from '@/services/link'
import { getTermListNew } from '@/services/term'
import { getPromotionList } from '@/services/promotion'
import PowerWrapper from '@/components/PowerWrapper'
import funcBlock from '@/components/common/funcBlock'
import { timestampToDate, delUndefined, numFormat, formatNumberRgx2 } from '@/utils/utils'
import { getTeamCode, getAgentCode, getTeamRole } from '@/utils/auth'
import { initOrderColumns } from '@/utils/constant'

export default {
  name: 'timeReportOrder',
  components: {
    Pagination,
    PowerWrapper,
    funcBlock,
    SubjectCascader
  },
  data() {
    return {
      CurrRole: 'timeOrder',
      dataList: [],
      orderColumns: [],
      listQuery: {
        index: 1,
        pageSize: 10,
        subject_type: '',
        dimension: 'day',
        course_id: null,
        promotion_position_id: null,
        term_id: null,
        member_id: (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) ? null : getAgentCode(),
        promotion_channel_id: null,
        orderColumn: 'dimension',
        orderType: 'asc',
        team_id: getTeamCode(),
        study_step: null,
        class_open_time: '',
        promotion_link_id: null,
        channel_group_id: []
      },
      createTime: [new Date(new Date().setHours(0, 0, 0, 0)).getTime() - 3600 * 1000 * 24 * 30, new Date(new Date().setHours(23, 59, 59, 0)).getTime()],
      classDate: null,
      pickerMinDate: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().setHours(0, 0, 0, 0))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '昨日',
            onClick(picker) {
              const start = new Date()
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000)
              end.setHours(23, 59, 59, 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本周',
            onClick(picker) {
              const end = new Date()
              const week = end.getDay()
              const millisecond = 1000 * 60 * 60 * 24
              const minusDay = week !== 0 ? week - 1 : 6
              const monday = new Date(end.getTime() - minusDay * millisecond)
              const start = new Date(monday)
              start.setHours(0, 0, 0, 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上周',
            onClick(picker) {
              const starta = new Date()
              var first = starta.getDate() - starta.getDay() - 6
              var startDate = new Date(starta.setDate(first))
              const start = new Date(startDate)
              start.setHours(0, 0, 0, 0)
              var currentDate = new Date()
              var firsts = currentDate.getDate() - currentDate.getDay() - 6
              var last = firsts + 6
              var endDate = new Date(currentDate.setDate(last))
              const end = new Date(endDate)
              end.setHours(23, 59, 59, 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const currentDate = new Date()
              const currentMonth = currentDate.getMonth()
              const currentYear = currentDate.getFullYear()
              const start = new Date(currentYear, currentMonth, 1)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const start = new Date()
              const end = new Date()
              const m = start.getMonth() - 1
              start.setDate(1)
              start.setMonth(m)
              end.setDate(0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime()
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const day1 = 93 * 24 * 3600 * 1000
            const maxTime = this.pickerMinDate + day1
            const minTime = this.pickerMinDate - day1
            return time.getTime() > maxTime || time.getTime() < minTime
          }
        }
      },
      total: 1,
      allTime: [
        { value: 'day', name: '分日' },
        { value: 'week', name: '分周' },
        { value: 'month', name: '分月' }
      ],
      listLoading: false,
      teamList: [],
      courseList: [],
      channelList: [],
      promotionList: [],
      termList: [],
      channelGroups: [],
      selectLoading: false,
      flagOrder: null
    }
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    this.getTableTitle()
    this.getList()
    this.getCourseList()
    this.getChannelList()
    this.getTeamList()
    this.getTermList()
    this.getChannelGroup()
  },
  methods: {
    async getTableTitle() {
      try {
        const res = await getOrderFormTitle(getTeamCode())
        const result = res && res.data
        if (result && result.errCode === 0) {
          const titleFields = Array.isArray(result.data) ? result.data : []
          this.orderColumns = initOrderColumns.filter(item => titleFields.includes(item.prop))
        } else if (result && result.errCode === 1016) {
          this.orderColumns = []
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.orderColumns = []
        }
      } catch (error) {
        this.orderColumns = []
        console.error('getOrderFormTitle error:', error)
      }
    },
    subjectCascaderChange(subject_type) {
      this.listQuery.subject_type = subject_type
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex === 0 ? 'row-special' : ''
    },
    numberFormat(num) {
      return numFormat(num)
    },
    formatCellValue(value, label) {
      if (value == null) {
        return label && label.includes('率') ? '0.00%' : label && (label.includes('数') || label.includes('量')) ? '0' : '--'
      }
      if (label && label.includes('率')) {
        return value !== undefined && value !== null ? `${formatNumberRgx2(value * 100)}%` : '0.00%'
      }
      if (label && (label.includes('数') || label.includes('量'))) {
        return numFormat(value)
      }
      return value
    },
    toggleSearch() {
      this.listQuery.orderColumn = 'dimension'
      this.listQuery.orderType = 'asc'
      this.listQuery.index = 1
      this.listQuery.pageSize = 10
      this.getTableTitle()
      this.getList('search')
    },
    changeDate() {
      this.handleSearch(null, 'date')
    },
    handleSearch() {
      const promotion_link_id = this.listQuery.promotion_link_id
      const idsArr = promotion_link_id ? promotion_link_id.replace(/[\uff0c]/g, ',').split(',') : []
      if (idsArr.length > 20) {
        this.$message({ type: 'error', message: '推广链接 ID 每次最多只能查 20 个，请删除掉多余的 ID' })
      } else {
        this.getTableTitle()
        this.getList('search')
      }
    },
    changeTableSort(column) {
      this.listQuery.orderColumn = column.prop
      this.listQuery.orderType = column.order === 'ascending' ? 'asc' : column.order === 'descending' ? 'desc' : this.flagOrder
      this.flagOrder = column.order === 'ascending' ? 'asc' : 'desc'
      this.getList()
    },
    handleChannel(value) {
      this.listQuery.promotion_position_id = null
      if (value && value.length && value.length === 1 && value[0] !== 'null') {
        this.getPromotionList(value[0])
      } else {
        this.promotionList = []
      }
    },
    downloadTable() {
      const { listQuery, createTime } = this
      const _listQuery = Object.assign({}, listQuery)
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key]
        if (Array.isArray(query) && query.indexOf('all') > -1) {
          _listQuery[key] = null
        }
      })
      const { course_id, promotion_channel_id, promotion_position_id, term_id, member_id, study_step, channel_group_id = [] } = _listQuery
      const params = {
        ..._listQuery,
        course_id: course_id && course_id.length && course_id.filter(item => item !== 'null').length ? course_id.filter(item => item !== 'null').join(',') : null,
        promotion_channel_id: promotion_channel_id && promotion_channel_id.length && promotion_channel_id.filter(item => item !== 'null').length ? promotion_channel_id.filter(item => item !== 'null').join(',') : null,
        promotion_position_id: promotion_position_id && promotion_position_id.length && promotion_position_id.filter(item => item !== 'null').length ? promotion_position_id.filter(item => item !== 'null').join(',') : null,
        term_id: term_id && term_id.length && term_id.filter(item => item !== 'null').length ? term_id.filter(item => item !== 'null').join(',') : null,
        member_id: member_id && member_id.length && member_id.filter(item => item !== 'null').length ? member_id.filter(item => item !== 'null').join(',') : null,
        is_renewal: study_step ? (study_step === '续报未截止' ? 1 : study_step === '续报已截止' ? 0 : null) : null,
        is_unlock: study_step ? (study_step === '首课未开课' ? 1 : study_step === '首课已开课' ? 0 : null) : null,
        channel_group_id: channel_group_id.join(','),
        start_date: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_date: createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        start_class_date: this.classDate && this.classDate[0] ? timestampToDate(this.classDate[0]) : null,
        end_class_date: this.classDate && this.classDate[1] ? timestampToDate(this.classDate[1]) : null,
        index: 1,
        pageSize: this.total
      }
      delete params.study_step
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)'
      })
      downloadOrderForm(delUndefined(params)).then(res => {
        setTimeout(() => {
          this.loading.close()
        }, 1000)
        const blobData = res && res.data ? res.data : res
        if (blobData && blobData.type && blobData.type === 'application/json') {
          const fr = new FileReader()
          fr.onload = (e) => {
            const result = e && e.target && e.target.result ? JSON.parse(e.target.result) : null
            this.$message({ type: 'error', message: `下载失败${result && result.errMsg ? `，${result.errMsg}` : ''}` })
          }
          fr.readAsText(blobData)
          return
        }
        const blob = new Blob([blobData])
        const downloadElement = document.createElement('a')
        const objectUrl = window.URL.createObjectURL(blob)
        downloadElement.href = objectUrl
        downloadElement.download = '订单维度报表.xls'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(objectUrl)
      }).catch(error => {
        setTimeout(() => {
          this.loading.close()
        }, 1000)
        this.$message({ type: 'error', message: error || '下载失败' })
      })
    },
    getList(btnName = '') {
      this.listLoading = true
      const { listQuery, createTime, classDate } = this
      const _listQuery = Object.assign({}, listQuery)
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key]
        if (Array.isArray(query) && query.indexOf('all') > -1) {
          _listQuery[key] = null
        }
      })
      const { course_id, promotion_channel_id, promotion_position_id, term_id, member_id, study_step, channel_group_id = [] } = _listQuery
      const params = {
        ..._listQuery,
        course_id: course_id && course_id.length && course_id.filter(item => item !== 'null').length ? course_id.filter(item => item !== 'null').join(',') : null,
        promotion_channel_id: promotion_channel_id && promotion_channel_id.length && promotion_channel_id.filter(item => item !== 'null').length ? promotion_channel_id.filter(item => item !== 'null').join(',') : null,
        promotion_position_id: promotion_position_id && promotion_position_id.length && promotion_position_id.filter(item => item !== 'null').length ? promotion_position_id.filter(item => item !== 'null').join(',') : null,
        term_id: term_id && term_id.length && term_id.filter(item => item !== 'null').length ? term_id.filter(item => item !== 'null').join(',') : null,
        member_id: member_id && member_id.length && member_id.filter(item => item !== 'null').length ? member_id.filter(item => item !== 'null').join(',') : null,
        is_renewal: study_step ? (study_step === '续报未截止' ? 1 : study_step === '续报已截止' ? 0 : null) : null,
        is_unlock: study_step ? (study_step === '首课未开课' ? 1 : study_step === '首课已开课' ? 0 : null) : null,
        channel_group_id: channel_group_id.join(','),
        start_date: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_date: createTime && createTime[1] ? timestampToDate(createTime[1]) : null,
        start_class_date: classDate && classDate[0] ? timestampToDate(classDate[0]) : null,
        end_class_date: classDate && classDate[1] ? timestampToDate(classDate[1]) : null
      }
      delete params.study_step
      if (btnName === 'search') {
        params.index = 1
      }
      const resTotal = getOrderFormNum(delUndefined({
        ...delUndefined(params),
        index: 1,
        pageSize: 1,
        orderColumn: null,
        orderType: null
      }))
      const resList = getOrderFormList(delUndefined({ ...delUndefined(params) }))
      Promise.all([resTotal, resList]).then(results => {
        const resultTotal = results && results.length && results[0] && results[0].data
        const res = results && results.length && results[1]
        const dataAcc = resultTotal && resultTotal.errCode === 0 && resultTotal.data && resultTotal.data.length > 0
          ? resultTotal.data[0] : {}
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
          this.listLoading = false
          const { data, total } = res.data
          const data_cnt = [{ ...dataAcc, data_cnt: total }]
          this.dataList = data_cnt.concat(data || [])
          this.total = total
          if (btnName === 'search') {
            this.listQuery.index = 1
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false
          this.dataList = []
          this.total = 0
        }
      }).catch(() => {
        this.listLoading = false
        this.dataList = []
        this.total = 0
      })
    },
    getPromotionList(channelCode) {
      const params = { teamCode: getTeamCode(), channelCode }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.promotionList = res.data.data
        } else {
          this.promotionList = []
        }
      })
    },
    getTeamList() {
      const params = { teamCode: getTeamCode() }
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          let teamArr = []
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [{ agentCode: 0, name: '无归属人' }]
            this.teamList = teamArr.concat(res.data.data)
          } else {
            teamArr = [
              { agentCode: getAgentCode(), name: '我的' },
              { agentCode: 0, name: '无归属人' }
            ]
            this.teamList = teamArr
          }
        } else {
          this.teamList = []
        }
      })
    },
    getCourseList() {
      getCourseList().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.courseList = res.data.data.list
        } else {
          this.courseList = []
        }
      })
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data
        } else {
          this.channelList = []
        }
      })
    },
    getTermList() {
      getTermListNew().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data
        } else {
          this.termList = []
        }
      })
    },
    getChannelGroup() {
      const teamCode = getTeamCode()
      getChannelGroup(teamCode).then(res => {
        const { data, errCode } = res.data || {}
        if (data && errCode === 0) {
          this.channelGroups = data.list || []
        } else {
          this.channelGroups = []
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../styles/common.less';
.special-weight {
  font-weight: bold;
  color: #606266;
}
.topRight {
  .selectWidth {
    margin-right: 10px;
    width: 100px;
  }
}
.blockTit {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
.blockTit:hover {
  text-decoration: underline;
}
.icon-question {
  cursor: pointer;
}
</style>
